import { render } from "./Nouvelles.vue?vue&type=template&id=550e3512"
import script from "./Nouvelles.vue?vue&type=script&lang=js"
export * from "./Nouvelles.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__